import { render, staticRenderFns } from "./GameMainInfo.vue?vue&type=template&id=117dc8ae&"
import script from "./GameMainInfo.vue?vue&type=script&lang=js&"
export * from "./GameMainInfo.vue?vue&type=script&lang=js&"
import style0 from "@/styles/GameMainInfo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports